module.exports = "<app-header pageTitle='{{title}}'></app-header>\r\n<div class=\"container-fluid topBar\">\r\n    \r\n</div>\r\n<main class=\"main\">    \r\n    <div class=\"container-fluid\" dynamicPage>\r\n        <router-outlet></router-outlet>\r\n    </div>\r\n    <app-sidebar ></app-sidebar>\r\n</main>\r\n<app-aside></app-aside>\r\n<app-footer></app-footer>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/dashboard/dashboard.component.html
// module id = ./src/app/views/dashboard/dashboard.component.html
// module chunks = main